import React, { useEffect, useState } from 'react';
//import $ from 'jquery';
import api from '../../../services/api';
import { Modal } from 'react-bootstrap';
import querystring from 'querystring';
import loadingGif from '../../../img/loading-gif.gif';

export function UniForm(props) {
	const [id, setId] = useState('');

	const [nome, setNome] = useState('');
	const [descricao, setDescricao] = useState('');
	const [status, setStatus] = useState('');
	const [multicard, setMulticard] = useState(0);
	const [conta, setConta] = useState('');
	const [loading, setLoading] = useState(false);

	//const [cidade, setCidade] = useState('');
	const [tipo, setTipo] = useState('');

	const [checkErrors, setCheckErrors] = useState(false);

	//const [unidade,setUnidade] = useState('')

	/*const [validations, setValidations0] = useState({
		nome: {
			valid: null,
			message: 'nome inválido',
			validator: () => {
				//////console.log('nome' + nome);
				return Boolean(nome && String(nome).length > 0);
			},
		},
		conta: {
			valid: null,
			message: 'conta inválida',
			validator: () => {
				return Boolean(conta && String(conta).length > 0);
			},
		},
		status: {
			valid: null,
			message: 'situação inválido',
			validator: () => {
				return Boolean(
					status === 0 || status === 1 || status === '0' || status === '1'
				);
			},
		},
		descricao: {
			valid: null,
			message: 'descrição inválido',
			validator: (descricao) => {
				return Boolean(descricao && String(descricao).length > 0);
			},
		},
	});

	/*function null2Empty(val) {
		if (val == null) return '';
		return val;
	}*/

	/*function resetForm() {
		setId('');
		setNome('');
		setDescricao('');
		setStatus('');
		setConta('');
	}*/
	/*
	function handleChangeInput(e) {
		const target = e.target;
		var value = target.value;
		if (target.type == 'checkbox') {
			value = target.checked ? 1 : 0;
		}

		const name = target.name;
		this.setState({
			[name]: value,
		});
	}
*/

	function checkarErros() {
		let error = false;
		////console.log(error);
		if (nome.length > 0);
		else {
			error = true;
		}

		if (conta > 0);
		else {
			error = true;
		}
		if (descricao.length > 0);
		else {
			error = true;
		}
		if (status === 0 || status === 1 || status === '0' || status === '1');
		else {
			error = true;
		}
		////console.log(error);

		return error;
	}

	function cancelForm() {
		if (props.item) {
			const item = props.item;

			setId(item.id);
			setNome(item.nome);
			setStatus(item.status.toString());
			setMulticard(item.multicard ? 1 : 0);
			setDescricao(item.descricao);
			setConta(item.conta.id);
		}
	}

	function showErrorMessage(key) {
		////////console.log(validations[key]);

		if (!checkErrors) return;

		if (key === 'nome') {
			if (nome.length > 0) return;
			return 'Nome invalido';
		} else if (key === 'conta') {
			////console.log(conta);
			if (conta > 0) return;
			return 'Conta invalido';
		} else if (key === 'descricao') {
			if (descricao.length > 0) return;
			return 'Descricao invalido';
		} else if (key === 'status') {
			if (status === 0 || status === 1 || status === '0' || status === '1')
				return;
			return 'Situação invalida';
		}

		//if (!validations[key] || validations[key].valid !== false) return;
		//return validations[key].message;
	}

	function handleSubmit(e) {
		//const self = this;
		////////console.log('SUBMIT', self.state);
		e.preventDefault();
		setLoading(true);

		if (loading) {
			return;
		}
		//////console.log(validations);
		setCheckErrors(false);

		if (checkarErros()) {
			////console.log('erro');
			setCheckErrors(true);
			setLoading(false);
			return;
		}

		////////console.log(status)

		const data = { nome, descricao, status, multicard, conta, id };
		//////console.log(data);

		const qsData = querystring.stringify(data);
		//////console.log(validations);
		//setLoading(false)

		const options = {
			//method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			//data: x,
			//url: '/admin/unidade',
		};

		api
			.post(
				'/admin/unidade',
				qsData,
				options
				//this.state
			)
			.then(({ data, status }) => {
				//////console.log(data);
				if (data === false) {
					alert('Solicitação inválida');
					setLoading(false);

					return;
				}

				if (data.errors) {
					//////console.log(data.errors);
					var keys = Object.keys(data.errors);
					var msgs = '';
					for (var i = 0; i < keys.length; i++) {
						msgs += data.errors[keys[i]] + '\n';
					}

					alert(msgs);
					setLoading(false);

					return;
				}

				if (status === 200 && data.id) {
					if (id) {
						//	$('#' + props.elementId + 'Elem')[0].reset();
					}

					if (typeof props.callback == 'function') {
						props.callback(data);
					}

					setModalVisible(false);
					setLoading(false);

					//$('#' + props.elementId).modal('hide');
				}
			});
	}

	//aqui
	/*function validate() {
		var valid = true;
		var keys = Object.keys({ ...validations });
		//////console.log(keys);

		for (var i = 0; i < keys.length; i++) {
			validations[keys[i]].valid = validations[keys[i]].validator(keys[i]);
			if (!validations[keys[i]].valid) {
				valid = false;
				continue;
			}
		}

		return valid;
	}
*/
	/*function setValidations() {
		setValidations0({
			nome: {
				valid: null,
				message: 'nome inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			conta: {
				valid: null,
				message: 'conta inválida',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			status: {
				valid: null,
				message: 'situação inválido',
				validator: (value) => {
					//////console.log('Valor: ' + value);
					if (value === 0 || value === '0' || value === '1' || value === 1)
						return true;

					return false;
				},
			},
			descricao: {
				valid: null,
				message: 'descrição inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
		});
	}*/

	function setItem() {
		const item = props.item;

		setId(item.id);
		setNome(item.nome);
		setStatus(item.status.toString());
		setMulticard(item.multicard ? 1 : 0);
		setDescricao(item.descricao);
		setConta(item.conta.id);
	}

	useEffect(() => {
		if (props.item) {
			setItem();
		}
		//setValidations();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.item]);

	const { modalVisible, setModalVisible } = props;

	return (
		<Modal
			show={modalVisible}
			onHide={() => {
				setModalVisible(false);
			}}>
			<Modal.Header>
				<h2 className='modal-title'>
					{props.item ? 'Editar Unidade' : 'Nova Unidade'}
				</h2>
			</Modal.Header>
			<Modal.Body>
				<form id={props.elementId + 'Elem'} onSubmit={handleSubmit}>
					<div className='modal-body'>
						<div className='form-group'>
							<label>Nome</label>
							<input
								className='form-control'
								type='text'
								name='nome'
								value={nome}
								onChange={(e) => {
									setNome(e.target.value);
								}}
								//onChange={handleChangeInput}
							/>
							<span className='text-danger'>{showErrorMessage('nome')}</span>
						</div>
						<div className='form-group'>
							<label>Conta</label>
							<select
								className='form-control'
								type='text'
								name='conta'
								value={conta}
								onChange={(e) => {
									setConta(e.target.value);
								}}
								//onChange={handleChangeInput}
							>
								<option value=''>Selecione</option>
								{props.contas.map((conta) => (
									<option value={conta.id} key={conta.id}>
										{conta.nome}
									</option>
								))}
							</select>
							<span className='text-danger'>{showErrorMessage('conta')}</span>
						</div>
						<div className='form-group'>
							<label>Situação</label>
							<select
								className='form-control'
								name='status'
								value={status}
								onChange={(e) => {
									////////console.log(e.target.value)
									setStatus(e.target.value.toString());
								}}
								//onChange={handleChangeInput}
							>
								<option value=''>Selecione</option>
								<option value='1'>Ativada</option>
								<option value='0'>Desativada</option>
							</select>
							<span className='text-danger'>{showErrorMessage('status')}</span>
						</div>
						<div className='form-group'>
							<label>Tipo</label>
							<select
								className='form-control'
								name='tipo'
								value={tipo}
								onChange={(e) => {
									////////console.log(e.target.value)
									setTipo(e.target.value.toString());
								}}
								//onChange={handleChangeInput}
							>
								<option value=''>Selecione</option>
								<option value='fixa'>Fixa</option>
								<option value='movel'>Móvel</option>
							</select>
							<span className='text-danger'>{showErrorMessage('tipo')}</span>
						</div>
						<div className='form-group'>
							<label>Descrição</label>
							<textarea
								className='form-control'
								name='descricao'
								value={descricao}
								onChange={(e) => {
									setDescricao(e.target.value);
								}}
								//onChange={handleChangeInput}
							></textarea>
							<span className='text-danger'>
								{showErrorMessage('descricao')}
							</span>
						</div>

						<div className='form-group'>
							<div className='form-check'>
								<input
									type='checkbox'
									className='form-check-input'
									checked={multicard ? 'checked' : ''}
									name='multicard'
									value={multicard}
									onChange={(e) => {
										let c = 0;
										if (e.target.checked) {
											c = 1;
										}

										setMulticard(c);
									}}
									//onChange={handleChangeInput}
									id={'multicardCheck' + props.elementId}
								/>
								<label
									className='form-check-label'
									htmlFor={'multicardCheck' + props.elementId}
									value='1'>
									Aceita múltiplos cartões
								</label>
							</div>
						</div>
					</div>
					<div className='modal-footer'>
						<button
							type='button'
							onClick={(e) => {
								e.preventDefault();
								cancelForm();
								setModalVisible(false);
							}}
							className='btn btn-light border'
							data-dismiss='modal'>
							Cancelar
						</button>
						<button
							type='submit'
							onClick={(e) => {
								e.preventDefault();

								handleSubmit(e);
								//setModalVisible(false);
							}}
							className='btn btn-primary'>
							{loading ? (
								<img className='loadingImg' src={loadingGif} alt='loading' />
							) : (
								'Salvar'
							)}
						</button>
					</div>
				</form>
			</Modal.Body>
			<Modal.Footer></Modal.Footer>
		</Modal>
	);
}

class UnidadeForm extends React.Component {
	constructor(props) {
		super(props);

		this.resetForm = this.resetForm.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChangeInput = this.handleChangeInput.bind(this);
		this.setValidations();

		this.state = {
			nome: '',
			descricao: '',
			status: '',
			multicard: '',
			conta: '',
			tipo: '',
			cidade: 0,
		};

		if (this.props.item) {
			const item = this.props.item;
			this.state = {
				id: item.id,
				nome: item.nome,
				status: item.status,
				multicard: item.multicard ? 1 : 0,
				descricao: item.descricao,
				conta: item.conta.id,
				tipo: item.tipo,
				cidade: item.cidade.id || 0,
			};
		}
	}

	null2Empty(val) {
		if (val == null) return '';
		return val;
	}

	resetForm() {
		this.setState({
			id: '',
			nome: '',
			descricao: '',
			status: '',
			conta: '',
			tipo: '',
			cidade: '',
		});
	}

	handleChangeInput(event) {
		const target = event.target;
		var value = target.value;
		if (target.type === 'checkbox') {
			value = target.checked ? 1 : 0;
		}

		const name = target.name;
		this.setState({
			[name]: value,
		});
	}

	showErrorMessage(key) {
		//////console.log(this.validations[key]);

		if (!this.validations[key] || this.validations[key].valid !== false) return;
		return this.validations[key].message;
	}

	handleSubmit(e, setModalVisible) {
		const self = this;

		if (this.state.loading) {
			//////console.log('loading');
			return;
		}

		//////console.log('SUBMIT', self.state);
		e.preventDefault();
		if (!this.validate()) {
			this.forceUpdate();
			return;
		}
		this.setState({ loading: true });

		//////console.log(this.state.status);
		const x = querystring.stringify(this.state);
		//console.log(x);
		const options = {
			method: 'POST',
			headers: { 'content-type': 'application/x-www-form-urlencoded' },
			data: x,
			url: '/admin/unidade',
		};

		api(options).then(({ data, status }) => {
			//////console.log(data);
			if (data === false) {
				alert('Solicitação inválida');
				this.setState({ loading: false });

				return;
			}

			if (data.errors) {
				var keys = Object.keys(data.errors);
				var msgs = '';
				for (var i = 0; i < keys.length; i++) {
					msgs += data.errors[keys[i]] + '\n';
				}

				alert(msgs);
				this.setState({ loading: false });

				return;
			}

			if (status === 200 && data.id) {
				if (!self.state.id) {
					//$('#' + self.props.elementId + 'Elem')[0].reset();
				}

				if (typeof self.props.callback == 'function') {
					self.props.callback(data);
				}


				this.setState({ loading: false });
				
				setModalVisible(false);

				//$('#' + self.props.elementId).modal('hide');
			}
		});

		//
		/*
		api
			.post('/admin/unidade', this.state, {
				headers: {
					'content-type': 'application/x-www-form-urlencoded',
					charSet: 'UTF-8',
				},
			})
			.then(({ data, status }) => {
				//////console.log(data);
				if (data === false) {
					alert('Solicitação inválida');
					return;
				}

				if (data.errors) {
					var keys = Object.keys(data.errors);
					var msgs = '';
					for (var i = 0; i < keys.length; i++) {
						msgs += data.errors[keys[i]] + '\n';
					}

					alert(msgs);
					return;
				}

				if (status === 200 && data.id) {
					if (!self.state.id) {
						$('#' + self.props.elementId + 'Elem')[0].reset();
					}

					if (typeof self.props.callback == 'function') {
						self.props.callback();
					}

					$('#' + self.props.elementId).modal('hide');
				}
			});*/
	}

	validate() {
		var valid = true;
		var keys = Object.keys(this.validations);
		//////console.log(keys);

		for (var i = 0; i < keys.length; i++) {
			this.validations[keys[i]].valid = this.validations[keys[i]].validator(
				this.state[keys[i]]
			);
			if (!this.validations[keys[i]].valid) {
				valid = false;
				continue;
			}
		}

		return valid;
	}

	setValidations() {
		this.validations = {
			nome: {
				valid: null,
				message: 'nome inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			conta: {
				valid: null,
				message: 'conta inválida',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			status: {
				valid: null,
				message: 'situação inválido',
				validator: (value) => {
					//////console.log('Valor:' + value);
					return ['0', '1'].indexOf(String(value)) > -1;
				},
			},
			descricao: {
				valid: null,
				message: 'descrição inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			tipo: {
				valid: null,
				message: 'tipo inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
			cidade: {
				valid: null,
				message: 'cidade inválido',
				validator: (value) => {
					return Boolean(value && String(value).length > 0);
				},
			},
		};
	}

	render() {
		const props = this.props;
		const unidade = this.state;
		const { modalVisible, setModalVisible } = props;
		////////console.log(item);

		return (
			<Modal
				show={modalVisible}
				onHide={() => {
					setModalVisible(false);
				}}>
				<Modal.Header>
					<h2 className='modal-title'>
						{props.item ? 'Editar Unidade' : 'Nova Unidade'}
					</h2>
				</Modal.Header>
				<Modal.Body>
					<form
						id={props.elementId + 'Elem'}
						onSubmit={(e) => {
							this.handleSubmit(e, setModalVisible);
						}}>
						<div className='modal-body'>
							<div className='form-group'>
								<label>Nome</label>
								<input
									className='form-control'
									type='text'
									name='nome'
									value={unidade.nome}
									onChange={this.handleChangeInput}
								/>
								<span className='text-danger'>
									{this.showErrorMessage('nome')}
								</span>
							</div>
							<div className='form-group'>
								<label>Conta</label>
								<select
									className='form-control'
									type='text'
									name='conta'
									value={unidade.conta}
									onChange={this.handleChangeInput}>
									<option value=''>Selecione</option>
									{props.contas.map((conta) => (
										<option value={conta.id} key={conta.id}>
											{conta.nome}
										</option>
									))}
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('conta')}
								</span>
							</div>
							<div className='form-group'>
								<label>Situação</label>
								<select
									className='form-control'
									name='status'
									value={unidade.status}
									onChange={this.handleChangeInput}>
									<option value=''>Selecione</option>
									<option value='1'>Ativada</option>
									<option value='0'>Desativada</option>
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('status')}
								</span>
							</div>
							<div className='form-group'>
								<label>Tipo</label>
								<select
									className='form-control'
									name='tipo'
									value={unidade.tipo}
									onChange={this.handleChangeInput}
									//onChange={handleChangeInput}
								>
									<option value=''>Selecione</option>
									<option value='fixo'>Fixa</option>
									<option value='movel'>Móvel</option>
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('tipo')}
								</span>
							</div>
							<div className='form-group'>
								<label>Cidade</label>
								<select
									className='form-control'
									name='cidade'
									value={unidade.cidade}
									onChange={this.handleChangeInput}
									//onChange={handleChangeInput}
								>
									<option value={0}>Selecione</option>
									{props.cidades.map((cidade) => {
										return <option value={cidade.id}>{cidade.nome}</option>;
									})}
								</select>
								<span className='text-danger'>
									{this.showErrorMessage('cidade')}
								</span>
							</div>
							<div className='form-group'>
								<label>Descrição</label>
								<textarea
									className='form-control'
									name='descricao'
									value={unidade.descricao}
									onChange={this.handleChangeInput}></textarea>
								<span className='text-danger'>
									{this.showErrorMessage('descricao')}
								</span>
							</div>
							<div className='form-group'>
								<div className='form-check'>
									<input
										type='checkbox'
										className='form-check-input'
										checked={unidade.multicard ? 'checked' : ''}
										name='multicard'
										value={unidade.multicard}
										onChange={this.handleChangeInput}
										id={'multicardCheck' + props.elementId}
									/>
									<label
										className='form-check-label'
										htmlFor={'multicardCheck' + props.elementId}
										value='1'>
										Aceita múltiplos cartões
									</label>
								</div>
							</div>
						</div>
						<div className='modal-footer'>
							<button
								type='button'
								onClick={(e) => {
									e.preventDefault();
									this.resetForm();
									setModalVisible(false);
								}}
								className='btn btn-light border'
								data-dismiss='modal'>
								Cancelar
							</button>
							<button
								type='submit'
								onClick={(e) => {
									e.preventDefault();
									this.handleSubmit(e, setModalVisible);
									//setModalVisible(false);
								}}
								className='btn btn-primary'>
								{unidade.loading ? (
									<img className='loadingImg' src={loadingGif} alt='loading' />
								) : (
									'Salvar'
								)}
							</button>
						</div>
					</form>
				</Modal.Body>
				<Modal.Footer></Modal.Footer>
			</Modal>
		);
	}
}

export default UnidadeForm;
